import axios from "axios";
import { GET_ALL_GALLERY, GET_ALL_GALLERY_CATEGORY, GET_ALL_GALLERY_FAILED, GET_ALL_GALLERY_SUCCESS, GET_ALL_UNSPLASH_ITEMS } from "../../constants/galleryConstant";

export const GetGalleryItems = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_GALLERY });
    try {
        const res = await axios.get(`/files`, {params: data});
        dispatch({ 
            type: GET_ALL_GALLERY_SUCCESS, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_GALLERY_FAILED, payload: error.message });
    }
};
export const GetUnsplashItems = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_GALLERY });
    try {
        const res = await axios.get(`/files/unsplash?keyword=${data.keyword}&page=${data.page}`);
        dispatch({ 
            type: GET_ALL_UNSPLASH_ITEMS, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_GALLERY_FAILED, payload: error.message });
    }
};
export const GetGalleryCategory = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_GALLERY });
    try {
        const res = await axios.get(`/essential/group?type=files`, {params: data});
        dispatch({ 
            type: GET_ALL_GALLERY_CATEGORY, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_GALLERY_FAILED, payload: error.message });
    }
};